"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _ui = require("@unite-us/ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ActionSelect = /*#__PURE__*/function (_Component) {
  _inherits(ActionSelect, _Component);
  var _super = _createSuper(ActionSelect);
  function ActionSelect(props) {
    var _this;
    _classCallCheck(this, ActionSelect);
    _this = _super.call(this, props);
    _this.state = {
      loading: false,
      selectedAction: undefined
    };
    _this.doAction = _this.doAction.bind(_assertThisInitialized(_this));
    _this.handleConfirmClick = _this.handleConfirmClick.bind(_assertThisInitialized(_this));
    _this.handleOnChange = _this.handleOnChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ActionSelect, [{
    key: "handleCancelClick",
    value: function handleCancelClick(e) {
      e.preventDefault();
      this.setState({
        loading: false,
        selectedAction: undefined
      }, this.resetValue);
    }
  }, {
    key: "doAction",
    value: function doAction(action) {
      var _this2 = this;
      if ((0, _lodash.isFunction)(action.action)) {
        this.setState({
          loading: true
        }, function () {
          var p = action.action();
          // Using Promise.all instead of p.then because it will still
          // call the then function even if p is not a promise.
          Promise.all([p]).then(function () {
            return _this2.setState({
              selectedAction: undefined,
              loading: false
            });
          });
        });
      }
    }
  }, {
    key: "handleConfirmClick",
    value: function handleConfirmClick(e, action) {
      e.preventDefault();
      this.doAction(action);
    }
  }, {
    key: "handleOnChange",
    value: function handleOnChange(val) {
      var _this3 = this;
      var action = (0, _lodash.find)(this.props.actions, function (act) {
        return act.value === val;
      });
      var requireConfirmation = this.props.requireConfirmation;
      var selectedAction = (0, _lodash.isEmpty)(action) ? undefined : action;
      this.setState({
        selectedAction: selectedAction
      }, function () {
        if (!requireConfirmation) {
          // It's a mystery why the timeout is needed, but it is...
          // some kind of react-select magic.
          setTimeout(function () {
            return _this3.doAction(action);
          }, 400);
        }
      });
      return this.props.onChange(selectedAction);
    }
  }, {
    key: "resetValue",
    value: function resetValue() {
      this.selectField.setValue('');
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        actions = _this$props.actions,
        disabled = _this$props.disabled,
        flat = _this$props.flat,
        id = _this$props.id,
        placeholder = _this$props.placeholder,
        label = _this$props.label,
        primary = _this$props.primary,
        requireConfirmation = _this$props.requireConfirmation,
        searchEnabled = _this$props.searchEnabled,
        styles = _this$props.styles,
        valueKey = _this$props.valueKey,
        labelKey = _this$props.labelKey;
      var _this$state = this.state,
        loading = _this$state.loading,
        selectedAction = _this$state.selectedAction;
      var actionSelectClass = function actionSelectClass() {
        return (0, _classnames["default"])({
          'ui-action-select': true
        });
      };
      var confirmationBlockClasses = function confirmationBlockClasses() {
        return (0, _classnames["default"])({
          'confirmation-block': true,
          shadow: !flat,
          hidden: (0, _lodash.isEmpty)(selectedAction) || !requireConfirmation
        });
      };
      var actionSelectContainerClasses = function actionSelectContainerClasses() {
        return (0, _classnames["default"])({
          'action-select-container': true,
          shadow: !flat,
          primary: primary
        });
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: actionSelectClass()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: actionSelectContainerClasses()
      }, /*#__PURE__*/_react["default"].createElement(_ui.SelectField, {
        ref: function ref(selectField) {
          _this4.selectField = selectField;
        },
        id: id,
        options: actions,
        disabled: loading || disabled,
        style: styles.selectStyle,
        placeholder: placeholder,
        onChange: this.handleOnChange,
        searchEnabled: searchEnabled,
        label: label,
        hideLabel: true,
        valueKey: valueKey,
        labelKey: labelKey
      })), loading ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: "confirmation-block-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: confirmationBlockClasses()
      }, /*#__PURE__*/_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick(e) {
          return _this4.handleConfirmClick(e, selectedAction);
        },
        className: "confirm-button"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "confirm-button__icon"
      }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconCheck"
      }))), /*#__PURE__*/_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick(e) {
          return _this4.handleCancelClick(e);
        },
        className: "cancel-button"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "cancel-button__icon"
      }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconTimes"
      }))))));
    }
  }]);
  return ActionSelect;
}(_react.Component);
ActionSelect.propTypes = {
  actions: _propTypes["default"].array,
  disabled: _propTypes["default"].bool,
  flat: _propTypes["default"].bool,
  /** id for reference */
  id: _propTypes["default"].string.isRequired,
  /** Key used for the label */
  labelKey: _propTypes["default"].string,
  /** onChange function from props */
  onChange: _propTypes["default"].func,
  /** Placeholder text */
  placeholder: _propTypes["default"].node,
  /** label label text field */
  label: _propTypes["default"].string,
  /** Used to determine background color of Select, primary/#4571BA, default/#ECF5FD */
  primary: _propTypes["default"].bool,
  requireConfirmation: _propTypes["default"].bool,
  /** Override the inline-styles of the elements || **Not Recommended** */
  styles: _propTypes["default"].shape({
    /** Styles passed into the SelectField component || **Not Recommended** */
    selectStyle: _propTypes["default"].object
  }),
  /** If true, search is enabled */
  searchEnabled: _propTypes["default"].bool,
  /** Key used for the value */
  valueKey: _propTypes["default"].string
};
ActionSelect.defaultProps = {
  actions: [],
  disabled: false,
  flat: true,
  onChange: _lodash.noop,
  placeholder: 'Take Action',
  label: 'Action Select',
  primary: false,
  requireConfirmation: false,
  valueKey: 'value',
  labelKey: 'label',
  searchEnabled: false,
  styles: {
    selectStyle: {}
  }
};
var _default = exports["default"] = ActionSelect;